import './UserAvatar.less';
import React from 'react';
import ImageHelper from "../../helpers/ImageHelper";
import config from "../../../../../config.json";
import __ from "../../i18n";
import AspectContainer from "../../../bootstrap/components/aspect-container/AspectContainer";


export default function UserAvatar({image}) {

    const avatarImageSrc = image ? ImageHelper.getUrl(image) : config.img_default_avatar;

    return <div className="user-avatar">
        <AspectContainer ratio={1}>
            <img src={avatarImageSrc} alt={__('Avatar image')}/>
        </AspectContainer>
    </div>;
}
